'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var document$1 = _interopDefault(require('global/document'));

function indexOf$1(array, target) {
    for (var i = 0, length = array.length; i < length; i++) {
        if (array[i] === target) {
            return i;
        }
    }
    return -1;
}

function addSelectedClass(el) {
    document.getElementById(el.id).classList.add('vjs-selected');
}
function removeSelectedClass(el) {
    document.getElementById(el.id).classList.remove('vjs-selected');

    if (el.thumbnail) {
        videojs.dom.removeClass(el.thumbnail, 'vjs-playlist-now-playing');
    }
}
function upNext(el) {
    document.getElementById(el.id).classList.add('vjs-up-next');
}
function notUpNext(el) {
    document.getElementById(el.id).classList.remove('vjs-up-next');
}

var utils = {
    indexOf: indexOf$1,
    addSelectedClass: addSelectedClass,
    removeSelectedClass: removeSelectedClass,
    upNext: upNext,
    notUpNext: notUpNext
};

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component$1 = videojs.getComponent('Component');
var PlaylistMenuItem = function (_Component) {
    inherits(PlaylistMenuItem, _Component);

    function PlaylistMenuItem(player, playlistItem) {
        classCallCheck(this, PlaylistMenuItem);

        if (!playlistItem.item) {
            throw new Error('Cannot construct a PlaylistMenuItem without an item option');
        }

        var _this = possibleConstructorReturn(this, _Component.call(this, player, playlistItem));

        _this.item = playlistItem.item;

        _this.playOnSelect = playlistItem.setting.playOnSelect;

        _this.emitTapEvents();

        _this.on(['click', 'tap'], _this.switchPlaylistItem_);
        _this.on('keydown', _this.handleKeyDown_);
        _this.options = playlistItem;
        _this.id = "playlistItem-" + _this.options.index;
        return _this;
    }

    PlaylistMenuItem.prototype.handleKeyDown_ = function handleKeyDown_(event) {
        // keycode 13 is <Enter>
        // keycode 32 is <Space>
        if (event.which === 13 || event.which === 32) {
            this.switchPlaylistItem_();
        }
    };

    PlaylistMenuItem.prototype.switchPlaylistItem_ = function switchPlaylistItem_(event) {
        this.player_.currentPlaylistIndex = this.options_.index;
        if (this.options.item) {
            eventHub.$emit('switchplaylistitem', this.player_.currentPlaylistIndex);
        }
    };

    PlaylistMenuItem.prototype.createEl = function createEl() {
        var li = document.createElement('li');
        var item = this.options_.item;

        li.className = 'vjs-playlist-item';
        li.id = "playlistItem-" + this.options_.index;
        li.setAttribute('tabIndex', 0);

        // Thumbnail image
        this.thumbnail = this.createThumbnail(item.thumbnail);
        li.appendChild(this.thumbnail);

        // Duration
        if (item.duration) {
            var duration = document.createElement('time');
            var time = videojs.formatTime(item.duration);

            duration.className = 'vjs-playlist-duration';
            duration.setAttribute('datetime', 'PT0H0M' + item.duration + 'S');
            duration.appendChild(document.createTextNode(time));
            li.appendChild(duration);
        }

        // Now playing
        var nowPlayingEl = document.createElement('span');
        // const nowPlayingText = this.player_.localize('playnow');
        var nowPlayingText = 'En cours';

        nowPlayingEl.className = 'vjs-playlist-now-playing-text';
        nowPlayingEl.appendChild(document.createTextNode(nowPlayingText));
        nowPlayingEl.setAttribute('title', nowPlayingText);
        this.thumbnail.appendChild(nowPlayingEl);

        // Title container contains title and "up next"
        var titleContainerEl = document.createElement('div');

        titleContainerEl.className = 'vjs-playlist-title-container';
        this.thumbnail.appendChild(titleContainerEl);

        // Up next
        var upNextEl = document.createElement('span');
        // const upNextText = this.player_.localize('next');
        var upNextText = 'Suivant';

        upNextEl.className = 'vjs-up-next-text';
        upNextEl.appendChild(document.createTextNode(upNextText));
        upNextEl.setAttribute('title', upNextText);
        titleContainerEl.appendChild(upNextEl);

        // Video title
        var titleEl = document.createElement('cite');
        var titleText = item.name || this.player_.localize('untitled');

        titleEl.className = 'vjs-playlist-name';
        titleEl.appendChild(document.createTextNode(titleText));
        titleEl.setAttribute('title', titleText);
        titleContainerEl.appendChild(titleEl);

        return li;
    };

    PlaylistMenuItem.prototype.createThumbnail = function createThumbnail(thumbnail) {
        if (!thumbnail) {
            var placeholder = document.createElement('div');

            placeholder.className = 'vjs-playlist-thumbnail vjs-playlist-thumbnail-placeholder';
            return placeholder;
        }

        var picture = document.createElement('picture');

        picture.className = 'vjs-playlist-thumbnail';

        if (typeof thumbnail === 'string') {
            // simple thumbnails
            var img = document.createElement('img');

            picture.appendChild(img);
        } else {
            // responsive thumbnails

            // additional variations of a <picture> are specified as
            // <source> elements
            for (var i = 0; i < thumbnail.length - 1; i++) {
                var _variant = thumbnail[i];
                var source = document.createElement('source');

                // transfer the properties of each variant onto a <source>
                for (var prop in _variant) {
                    if (_variant[prop] === "") {
                        source[prop] = "";
                    } else {
                        source[prop] = _variant[prop];
                    }
                }
                picture.appendChild(source);
            }

            // the default version of a <picture> is specified by an <img>
            var variant = thumbnail[thumbnail.length - 1];
            var _img = document.createElement('img');
            _img.alt = '';
            for (var _prop in variant) {
                if (variant[_prop] === "") {
                    _img[_prop] = "data:image/jpeg;base64,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\n";
                } else {
                    _img[_prop] = variant[_prop];
                }
            }
            picture.appendChild(_img);
        }
        return picture;
    };

    return PlaylistMenuItem;
}(Component$1);

var Component = videojs.getComponent('Component');
// support VJS5 & VJS6 at the same time
var dom$1 = videojs.dom || videojs;

var PlaylistMenu = function (_Component) {
  inherits(PlaylistMenu, _Component);

  function PlaylistMenu(player, options) {
    classCallCheck(this, PlaylistMenu);

    if (!player.playlist) {
      throw new Error('videojs-playlist is required for the playlist component');
    }

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.items = [];
    _this.options = options;
    _this.player = player;
    if (options.horizontal) {
      _this.addClass('vjs-playlist-horizontal');
    } else {
      _this.addClass('vjs-playlist-vertical');
    }

    // If CSS pointer events aren't supported, we have to prevent
    // clicking on playlist items during ads with slightly more
    // invasive techniques. Details in the stylesheet.
    if (options.supportsCssPointerEvents) {
      _this.addClass('vjs-csspointerevents');
    }

    _this.createPlaylist_();

    if (!videojs.browser.TOUCH_ENABLED) {
      _this.addClass('vjs-mouse');
    }
    var self = _this;

    eventHub.$on('switchplaylistitem', function (index) {
      self.update(index);
      eventHub.$emit('nextVideo', index);
    });

    // Keep track of whether an ad is playing so that the menu
    // appearance can be adapted appropriately
    player.on('adstart', function () {
      self.addClass('vjs-ad-playing');
    });

    player.on('adend', function () {
      self.removeClass('vjs-ad-playing');
    });
    _this.player = player;
    return _this;
  }

  PlaylistMenu.prototype.createEl = function createEl() {
    return dom$1.createEl('div', { className: this.options.className });
  };

  PlaylistMenu.prototype.createPlaylist_ = function createPlaylist_() {
    var playlist = this.options.sources || [];
    // this.player_.playlist.repeat(true);
    var list = this.el_.querySelector('.vjs-playlist-item-list');
    var overlay = this.el_.querySelector('.vjs-playlist-ad-overlay');

    if (!list) {
      list = document.createElement('ol');
      list.className = 'vjs-playlist-item-list';
      this.el_.appendChild(list);
    }

    // remove any existing items
    for (var i = 0; i < this.items.length; i++) {
      list.removeChild(this.items[i].el_);
    }
    this.items.length = 0;

    // create new items
    for (var _i = 0; _i < playlist.length; _i++) {
      var item = this.addChild('PlaylistMenuItem', {
        item: playlist[_i],
        index: _i,
        setting: this.options
      });

      this.items.push(item);
      list.appendChild(item.el_);
    }

    // Inject the ad overlay. IE<11 doesn't support "pointer-events:
    // none" so we use this element to block clicks during ad
    // playback.
    if (!overlay) {
      overlay = document.createElement('li');
      overlay.className = 'vjs-playlist-ad-overlay';
      list.appendChild(overlay);
    } else {
      // Move overlay to end of list
      list.appendChild(overlay);
    }

    // select the current playlist item
    var selectedIndex = this.player.currentPlaylistIndex;

    if (this.items.length && selectedIndex >= 0) {
      utils.addSelectedClass(this.items[selectedIndex]);

      var thumbnail = this.items[selectedIndex].$('.vjs-playlist-thumbnail');

      if (thumbnail) {
        dom$1.addClass(thumbnail, 'vjs-playlist-now-playing');
      }
    }
  };

  PlaylistMenu.prototype.update = function update(index) {
    // replace the playlist items being displayed, if necessary
    var playlist = this.options.sources || [];
    if (this.items.length !== playlist.length) {
      // if the menu is currently empty or the state is obviously out
      // of date, rebuild everything.
      this.createPlaylist_();
      return;
    }

    for (var i = 0; i < this.items.length; i++) {
      if (this.items[i].item !== playlist[i]) {
        // if any of the playlist items have changed, rebuild the
        // entire playlist
        this.createPlaylist_();
        return;
      }
    }

    // the playlist itself is unchanged so just update the selection
    var currentItem = void 0;
    if (index === undefined) {
      currentItem = this.player_.currentPlaylistIndex;
    } else {
      currentItem = index;
    }

    for (var _i2 = 0; _i2 < this.items.length; _i2++) {
      var item = this.items[_i2];

      if (_i2 === currentItem) {
        utils.addSelectedClass(item);
        if (document.activeElement !== item.el()) {
          dom$1.addClass(item.thumbnail, 'vjs-playlist-now-playing');
        }
        utils.notUpNext(item);
      } else if (_i2 === currentItem + 1) {
        utils.removeSelectedClass(item);
        utils.upNext(item);
      } else {
        utils.removeSelectedClass(item);
        utils.notUpNext(item);
      }
    }
  };

  return PlaylistMenu;
}(Component);

// support VJS5 & VJS6 at the same time
var dom = videojs.dom || videojs;
var registerPlugin = videojs.registerPlugin || videojs.plugin;

// see https://github.com/Modernizr/Modernizr/blob/master/feature-detects/css/pointerevents.js
var supportsCssPointerEvents = function () {
  var element = document$1.createElement('x');

  element.style.cssText = 'pointer-events:auto';
  return element.style.pointerEvents === 'auto';
}();

var defaults = {
  className: 'vjs-playlist',
  playOnSelect: true,
  supportsCssPointerEvents: supportsCssPointerEvents,
  mp4: false
};

/**
 * Returns a boolean indicating whether an element has child elements.
 *
 * Note that this is distinct from whether it has child _nodes_.
 *
 * @param  {HTMLElement} el
 *         A DOM element.
 *
 * @return {boolean}
 *         Whether the element has child elements.
 */
var hasChildEls = function hasChildEls(el) {
  for (var i = 0; i < el.childNodes.length; i++) {
    if (dom.isEl(el.childNodes[i])) {
      return true;
    }
  }
  return false;
};

/**
 * Finds the first empty root element.
 *
 * @param  {string} className
 *         An HTML class name to search for.
 *
 * @return {HTMLElement}
 *         A DOM element to use as the root for a playlist.
 */
var findRoot = function findRoot(className) {
  var all = document$1.querySelectorAll('.' + className);
  var el = void 0;

  for (var i = 0; i < all.length; i++) {
    if (!hasChildEls(all[i])) {
      el = all[i];
      break;
    }
  }

  return el;
};

/**
 * Initialize the plugin on a player.
 *
 * @param  {Object} [options]
 *         An options object.
 *
 * @param  {HTMLElement} [options.el]
 *         A DOM element to use as a root node for the playlist.
 *
 * @param  {string} [options.className]
 *         An HTML class name to use to find a root node for the playlist.
 *
 * @param  {boolean} [options.playOnSelect = false]
 *         If true, will attempt to begin playback upon selecting a new
 *         playlist item in the UI.
 */
var playlistUep = function playlistUep(options) {
  var player = this;
  if (!player.playlist) {
    throw new Error('videojs-playlist plugin is required by the videojs-playlist-ui plugin');
  }

  if (dom.isEl(options)) {
    videojs.log.warn('videojs-playlist-ui: Passing an element directly to playlistUi() is deprecated, use the "el" option instead!');
    options = { el: options };
  }

  options = videojs.mergeOptions(defaults, options);

  // If the player is already using this plugin, remove the pre-existing
  // PlaylistMenu, but retain the element and its location in the DOM because
  // it will be re-used.
  if (player.playlistMenu) {
    var el = player.playlistMenu.el();

    // Catch cases where the menu may have been disposed elsewhere or the
    // element removed from the DOM.
    if (el) {
      var parentNode = el.parentNode;
      var nextSibling = el.nextSibling;

      // Disposing the menu will remove `el` from the DOM, but we need to
      // empty it ourselves to be sure.
      player.playlistMenu.dispose();
      dom.emptyEl(el);

      // Put the element back in its place.
      if (nextSibling) {
        parentNode.insertBefore(el, nextSibling);
      } else {
        parentNode.appendChild(el);
      }

      options.el = el;
    }
  }
  if (options.controlBarOptions) {
    options.horizontal = false;
    var upBtn = document$1.createElement("button");
    upBtn.className = "vjs-button-up";
    upBtn.onclick = functionUpVideo;

    player.controlBar.el().insertBefore(upBtn, player.controlBar.volumePanel.el());

    /*let changeBtn = document.createElement("button");
     changeBtn.className = "vjs-button-changeBtn";
     changeBtn.onclick = changeSlideVideo;
      player.controlBar.el().insertBefore(changeBtn, player.controlBar.playToggle.el());*/

    var nextBtn = document$1.createElement("button");
    nextBtn.className = "vjs-button-next";
    nextBtn.onclick = functionNextVideo;

    player.controlBar.el().insertBefore(nextBtn, player.controlBar.volumePanel.el());

    if (!dom.isEl(options.el)) {
      options.el = findRoot(options.className);
    }
    if (player.currentPlaylistIndex === undefined) {
      player.currentPlaylistIndex = 0;
    }

    player.on('ended', function (event) {
      functionNextVideo();
    });

    player.playlistMenu = new PlaylistMenu(player, options);
  }

  function functionNextVideo() {
    if (options.mp4) {
      var index = player.playlist.currentItem();
      switchPlaylistItemWithIndex_(index + 1);
    } else {
      player.pause();
      player.currentPlaylistIndex = player.currentPlaylistIndex + 1;
      if (options.sources[player.currentPlaylistIndex]) {
        //Todo switchplaylistitem
        eventHub.$emit('switchplaylistitem', player.currentPlaylistIndex);
      } else if (options.loop) {
        player.currentPlaylistIndex = 0;
        //Todo switchplaylistitem
        eventHub.$emit('switchplaylistitem', player.currentPlaylistIndex);
      }
    }
  }
  function functionUpVideo() {
    if (options.mp4) {
      var index = player.playlist.currentItem();
      switchPlaylistItemWithIndex_(index - 1);
    } else {
      player.pause();
      player.currentPlaylistIndex = player.currentPlaylistIndex - 1;
      if (options.sources[player.currentPlaylistIndex]) {
        //Todo switchplaylistitem
        eventHub.$emit('switchplaylistitem', player.currentPlaylistIndex);
      } else if (options.loop) {
        player.currentPlaylistIndex = options.sources.length - 1;
        //Todo switchplaylistitem
        eventHub.$emit('switchplaylistitem', player.currentPlaylistIndex);
      }
    }
  }

  function switchPlaylistItemWithIndex_(index) {
    player.playlist.currentItem(index);
    if (options.playOnSelect) {
      player.play();
    }
  }
};

// register components
videojs.registerComponent('PlaylistMenu', PlaylistMenu);
videojs.registerComponent('PlaylistMenuItem', PlaylistMenuItem);

// register the plugin
registerPlugin('playlistUep', playlistUep);

module.exports = playlistUep;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_playlist_uep/dist/videojs-playlist-uep.cjs.js
// module id = 1123
// module chunks = 0